import { cn } from '@/ui/utils';

type IconProps = React.ComponentProps<'svg'>;

export const Icons = {
  orderDirection: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      color="currentColor"
      {...props}
    >
      <path
        d="M11 20H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11 16H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11 12H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3 7.99997C3 7.99997 5.94596 4.00001 7.00003 4C8.05411 3.99999 11 8 11 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M7 5V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  sharepoint: (props: IconProps) => (
    <svg
      width="48"
      height="46"
      viewBox="0 0 48 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_96_1217)">
        <path
          d="M24.5579 26.2857C31.956 26.2857 37.9533 20.4015 37.9533 13.1429C37.9533 5.88426 31.956 0 24.5579 0C17.1599 0 11.1626 5.88426 11.1626 13.1429C11.1626 20.4015 17.1599 26.2857 24.5579 26.2857Z"
          fill="#036C70"
        />
        <path
          d="M35.721 37.2378C42.5025 37.2378 48.0001 31.8439 48.0001 25.1902C48.0001 18.5365 42.5025 13.1426 35.721 13.1426C28.9394 13.1426 23.4419 18.5365 23.4419 25.1902C23.4419 31.8439 28.9394 37.2378 35.721 37.2378Z"
          fill="#1A9BA1"
        />
        <path
          d="M26.2325 45.9999C31.4728 45.9999 35.7209 41.8319 35.7209 36.6904C35.7209 31.5489 31.4728 27.3809 26.2325 27.3809C20.9922 27.3809 16.7441 31.5489 16.7441 36.6904C16.7441 41.8319 20.9922 45.9999 26.2325 45.9999Z"
          fill="#37C6D0"
        />
        <path
          opacity="0.1"
          d="M26.7905 11.8617V35.2341C26.785 36.0462 26.2834 36.7758 25.518 37.085C25.2743 37.1862 25.0123 37.2383 24.7477 37.2384H16.7552C16.744 37.0522 16.744 36.8769 16.744 36.6907C16.7403 36.5079 16.7477 36.3251 16.7663 36.1431C16.9707 32.6421 19.1689 29.5532 22.4482 28.1588V26.1217C15.1499 24.9869 10.1709 18.2621 11.3275 11.1013C11.3355 11.0517 11.3438 11.0022 11.3524 10.9527C11.408 10.5833 11.4863 10.2175 11.5868 9.85742H24.7478C25.8742 9.86163 26.7862 10.7565 26.7905 11.8617Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M23.6317 10.9521H11.3526C10.1122 18.1 15.0125 24.8811 22.2976 26.0982C22.5182 26.135 22.7397 26.1664 22.9619 26.1924C19.5015 27.8024 16.9798 32.375 16.7655 36.1426C16.7469 36.3246 16.7394 36.5074 16.7431 36.6902C16.7431 36.8764 16.7431 37.0517 16.7543 37.2379C16.7744 37.606 16.8229 37.9721 16.8994 38.3331H23.6306C24.4583 38.3277 25.2019 37.8355 25.5171 37.0845C25.6201 36.8454 25.6733 36.5884 25.6733 36.3288V12.9564C25.6691 11.8517 24.7577 10.957 23.6317 10.9521Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M23.6316 10.9521H11.3525C10.1124 18.1007 15.0134 24.8821 22.2992 26.0989C22.4483 26.1238 22.5977 26.1462 22.7475 26.1661C19.3987 27.8922 16.9764 32.4539 16.7665 36.1426H23.6316C24.7563 36.1343 25.6659 35.2418 25.6744 34.1383V12.9564C25.6701 11.8513 24.758 10.9564 23.6316 10.9521Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M22.5154 10.9521H11.3527C10.1816 17.7004 14.4914 24.1991 21.2541 25.8824C18.6934 28.7529 17.1228 32.344 16.7666 36.1426H22.5155C23.6419 36.1384 24.554 35.2435 24.5583 34.1383V12.9564C24.5576 11.8498 23.6434 10.9528 22.5154 10.9521Z"
          fill="black"
        />
        <path
          d="M2.04614 10.9521H22.512C23.642 10.9521 24.5581 11.851 24.5581 12.9597V33.0398C24.5581 34.1486 23.642 35.0474 22.512 35.0474H2.04614C0.916088 35.0474 0 34.1486 0 33.0398V12.9597C0 11.851 0.916088 10.9521 2.04614 10.9521Z"
          fill="url(#paint0_linear_96_1217)"
        />
        <path
          d="M9.13912 22.7544C8.65961 22.4424 8.25908 22.0269 7.96814 21.5398C7.68623 21.0306 7.54573 20.4576 7.56069 19.8783C7.53558 19.094 7.80535 18.328 8.31863 17.7262C8.85801 17.1236 9.5552 16.6774 10.3346 16.436C11.2229 16.1491 12.1534 16.0077 13.0885 16.0176C14.3182 15.9735 15.5463 16.1422 16.7164 16.5159V19.035C16.208 18.7328 15.6542 18.511 15.0755 18.3779C14.4475 18.2268 13.8031 18.151 13.1566 18.1522C12.4748 18.1277 11.7973 18.2684 11.1841 18.5619C10.7107 18.7622 10.4037 19.2192 10.4027 19.725C10.4008 20.0318 10.5209 20.3273 10.7376 20.5486C10.9935 20.8095 11.2962 21.0219 11.6306 21.1751C12.0027 21.3569 12.5609 21.5986 13.3051 21.9002C13.387 21.9256 13.4669 21.9571 13.5439 21.9944C14.2764 22.2752 14.9829 22.6171 15.6559 23.0162C16.1656 23.3245 16.5933 23.7472 16.9039 24.2494C17.2224 24.8188 17.3768 25.4624 17.3504 26.1114C17.3868 26.9166 17.1357 27.7091 16.6405 28.3522C16.1469 28.9435 15.487 29.3792 14.7428 29.6052C13.8676 29.8743 12.9541 30.0045 12.037 29.9907C11.2141 29.9943 10.3925 29.9284 9.58115 29.7935C8.8961 29.6835 8.22759 29.4908 7.59083 29.2196V26.5637C8.1995 26.9902 8.8795 27.309 9.60013 27.5056C10.3183 27.7252 11.0649 27.8425 11.8171 27.8539C12.5132 27.8971 13.2081 27.7524 13.8264 27.4355C14.2594 27.1957 14.5228 26.7415 14.5118 26.2537C14.5147 25.9143 14.3778 25.5881 14.1322 25.3491C13.8268 25.0549 13.4733 24.8132 13.0863 24.6339C12.6398 24.4148 11.9823 24.1261 11.1138 23.7675C10.4229 23.495 9.76143 23.1556 9.13912 22.7544Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_96_1217"
          x1="4.26625"
          y1="9.38348"
          x2="19.8388"
          y2="36.8727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#058F92" />
          <stop offset="0.5" stopColor="#038489" />
          <stop offset="1" stopColor="#026D71" />
        </linearGradient>
        <clipPath id="clip0_96_1217">
          <rect width="48" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  filters: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 4H14M4.66667 8H11.3333M6.66667 12H9.33333"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  documentXIcon: ({ className, ...props }: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_14188_29765)">
        <path
          d="M12.3208 3.67676L11.3208 4.67676M11.3208 4.67676L10.3208 5.67676M11.3208 4.67676L12.3208 5.67676M11.3208 4.67676L10.3208 3.67676"
          stroke="currentCOlor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6634 1.3476C4.99775 1.27708 3.71091 1.46896 3.71091 1.46896C2.89834 1.52706 1.34114 1.98261 1.34115 4.64307C1.34116 7.28091 1.32392 10.5329 1.34115 11.8293C1.34115 12.6214 1.83156 14.4689 3.529 14.5679C5.59223 14.6883 9.30866 14.7139 11.0138 14.5679C11.4703 14.5422 12.9899 14.1838 13.1823 12.5304C13.3815 10.8176 13.3419 9.62718 13.3419 9.34384"
          stroke="currentCOlor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 4.67708C14.6667 6.51803 13.1729 8.01044 11.3302 8.01044C9.48745 8.01044 7.99365 6.51803 7.99365 4.67708C7.99365 2.83614 9.48745 1.34375 11.3302 1.34375C13.1729 1.34375 14.6667 2.83614 14.6667 4.67708Z"
          stroke="currentCOlor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.65381 8.677H7.32046"
          stroke="currentCOlor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.65381 11.3438H9.98712"
          stroke="currentCOlor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14188_29765">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  files: ({ className, ...props }: IconProps) => (
    <svg
      className={cn('size-36', className)}
      viewBox="0 0 142 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M98.7122 70.2232L90.3142 65.3752L59.7287 47.7139L51.3308 33.2366L39.9375 26.658L17.75 13.8447V90.913L101.707 139.393V71.9538L98.7122 70.2232ZM84.9116 100.798L77.0683 96.2602L76.5247 95.9496V105.579L68.1267 100.731V91.1016L59.7287 86.2536V76.6243L68.1267 81.4611V71.8318L76.5247 76.6797V86.3091L77.0794 86.6308L84.9116 91.1571V100.798Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.5269 76.68V77.268L68.1289 81.4614V71.832L76.5269 76.68Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.0772 86.6316L68.1245 91.1023L59.7266 86.2544V76.625L68.1245 81.4619L76.5225 77.2684V86.3098L77.0772 86.6316Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.9138 91.1571V91.7562L76.5269 95.9496V96.5376L72.4333 98.5788L68.1289 100.731V91.1016L77.0816 86.6309L84.9138 91.1571Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.9103 91.7568V100.798L77.067 96.2609L76.5234 95.9503L84.9103 91.7568Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.895 60.8604V128.299L101.707 139.393V71.9541L123.895 60.8604Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.893 60.86L101.705 71.9537L98.71 70.2231L90.312 65.3751L59.7266 47.7139L81.9141 36.6201L123.893 60.86Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.9175 36.6209L59.73 47.7146L51.332 33.2373L73.5195 22.1436L81.9175 36.6209Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.5183 22.1429L51.3308 33.2366L39.9375 26.658L17.75 13.8447L39.9375 2.75098L73.5183 22.1429Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.5269 96.5381V105.579L68.1289 100.732L72.4333 98.5793L76.5269 96.5381Z"
        fill="#FAFAFA"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  slash: (props: IconProps) => (
    <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 3.5L4 11.5"
        stroke="#696A71"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  procore: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <g clipPath="url(#procoreMark)">
        <rect width="48" height="48" fill="#000" />
        <path
          fill="#fff"
          d="M48 16.3 37.337 16.3 24 8.6 10.663 16.3 10.663 31.7 24 39.4 37.337 31.7 48 31.7 48 28.7 32.141 28.7 24 33.4 15.859 28.7 15.859 19.3 24 14.6 32.141 19.3 48 19.3Z"
        />
        <path
          fill="#FF5C00"
          d="M24 17.3 29.802 20.65 29.802 27.35 24 30.7 18.198 27.35 18.198 20.65Z"
        />
      </g>
      <defs>
        <clipPath id="procoreMark">
          <rect width="48" height="48" rx="11" />
        </clipPath>
      </defs>
    </svg>
  ),
};
